import { render, staticRenderFns } from "./Naka.vue?vue&type=template&id=75be505c&scoped=true&"
import script from "./Naka.vue?vue&type=script&lang=ts&"
export * from "./Naka.vue?vue&type=script&lang=ts&"
import style0 from "./Naka.vue?vue&type=style&index=0&id=75be505c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75be505c",
  null
  
)

export default component.exports